
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "DiagnosticCriteriaForPelvicInflammatoryDisease",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/DiagnosticCriteriaForPelvicInflammatoryDisease.vue